import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRestrictedActionFormState() {
  return useAppState();
}

export function useRestrictedActionFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        groupId: '',
        restrictedActionName: '',
        resourceId: '',
        resourceType: '',
        applyToAllUsers: false,
      },
    }));
  }

  function updateForm(restrictedAction) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: restrictedAction,
    }));
  }

  function updateGroupId(groupId) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        ...state.restrictedActionForm,
        groupId,
      },
    }));
  }

  function updateRestrictedActionName(restrictedActionName) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        ...state.restrictedActionForm,
        restrictedActionName,
      },
    }));
  }

  function updateResourceId(resourceId) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        ...state.restrictedActionForm,
        resourceId,
      },
    }));
  }

  function updateResourceType(resourceType) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        ...state.restrictedActionForm,
        resourceType,
      },
    }));
  }

  function updateApplyToAllUsers(applyToAllUsers) {
    dispatch((state) => ({
      ...state,
      restrictedActionForm: {
        ...state.restrictedActionForm,
        applyToAllUsers,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateForm,
    updateGroupId,
    updateRestrictedActionName,
    updateResourceId,
    updateResourceType,
    updateApplyToAllUsers,
    onResponse,
    onError,
    clearFeedback,
  };
}
